import { useRecordContext } from 'react-admin';
import { Box, Typography, LinearProgress } from '@mui/material';

export const TagProgressBar = () => {
  const record = useRecordContext();
  if (!record || !record.weight) return null;

  const weight = Number(record.weight);
  const consumedGrams = Number(record.consumedGrams);
  const remaining = weight - consumedGrams;
  const percentage = (consumedGrams / weight) * 100;

  return (
    <Box sx={{ width: '100%', mt: 1 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {consumedGrams.toFixed(2)} g consumed
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {remaining.toFixed(2)} g remaining
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={Math.min(percentage, 100)}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          '& .MuiLinearProgress-bar': {
            backgroundColor:
              percentage > 80 ? 'error.main' : percentage > 60 ? 'warning.main' : 'success.main',
          },
        }}
      />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        {percentage.toFixed(1)}% used
      </Typography>
    </Box>
  );
};
